import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-subject-building-process-modal',
  components: {
    EdSubjectBuildingProcess: () => import(/* EdSubjectBuildingProcess */'@/courses/components/ed-subject-builder/ed-subject-building-process/ed-subject-building-process.component.vue'),
  }
})
export default class EdSubjectBuildingProcessModalComponent extends Vue {
  @Prop() readonly contentId: number;
  @Prop({ default: false }) readonly processFailed: boolean;

  hideModal() {
    this.$EdModal.closeModal();
  }

  getLogs() {
    setTimeout(() => {
      const subjectBuildingProcess: any = this.$refs?.subjectBuildingProcess;
  
      subjectBuildingProcess?.getLogs();
    }, 500);
  }

  mounted() {
    this.getLogs();
  }

}